import { motion } from 'framer-motion';
import styled from 'styled-components';

export const NewPersonCardWrapper = styled(motion.div)`
  width: 100%;
  max-width: 300px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  padding: 16px;

  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, 0.1);

  position: relative;
`;

export const NewPersonCardSparkleContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const NewPersonCardBackground = styled.img.attrs({
  src: '/images/person-card/background.png',
})`
  width: 100%;
  height: 64px;

  position: absolute;
  top: 0;
  left: 0;

  border-radius: 20px 20px 0 0;

  object-fit: cover;
`;

export const NewPersonCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 20px;
`;

export const NewPersonCardName = styled.span`
  font-weight: 400;
  font-size: 24px;
  line-height: normal;
  text-align: center;

  color: var(--color-text);
`;

export const NewPersonCardExperienceItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

interface NewPersonCardExperienceItemIconProps {
  type: 'account_holder' | 'client' | 'industry';
}

export const NewPersonCardExperienceItemIcon = styled.div<NewPersonCardExperienceItemIconProps>`
  display: inline-flex;
  border-radius: 100%;
  padding: 3px;
  margin-right: 5px;
  min-width: 20px;
  min-height: 20px;
  transform: translateY(2px);
  align-items: center;
  justify-content: center;
  background-color: ${({ type }) => {
    if (type === 'account_holder') {
      return 'none';
    } else if (type === 'client') {
      return 'var(--color-data-client-background)';
    } else if (type === 'industry') {
      return 'var(--color-data-industry-background)';
    }
  }};
  border: ${({ type }) => {
    if (type === 'account_holder') {
      return '1px solid black';
    } else {
      return 'none';
    }
  }};
`;

export const NewPersonCardExperienceItemLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  text-align: center;

  color: var(--color-text);
`;

export const NewPersonCardRole = styled.span`
  display: inline;

  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  line-height: 20px;

  color: var(--color-text);

  & > svg {
    transform: translate(10px, 4px);
  }
`;

export const NewPersonCardPulseLead = styled.span`
  display: inline;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  align-items: center;
  color: rgba(198, 216, 67, 1);

  & > svg {
    margin-bottom: -4px;
    margin-left: -1px;
  }
`;

export const NewPersonCardPillsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
`;

export const NewPersonCardPillsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
`;

export const NewPersonCardPillsLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  text-align: center;
  color: rgba(23, 28, 51, 0.5);
`;

export const NewPersonCardInformationWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const NewPersonCardInformationItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  & > svg {
    min-width: 16px;
    min-height: 16px;
  }
`;

export const NewPersonCardInformationItemLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  text-align: center;

  & > svg {
    transform: translate(-4px, 2px);
  }
`;

export const NewPersonCardInformationButtonContainer = styled.div`
  width: 100%;
  flex: 1;

  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

export const NewPersonCardInformationButton = styled.button`
  width: 100%;
  height: fit-content;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;

  padding: 13px 63px;

  border-radius: 8px;
  background: var(--color-data-people-foreground);

  color: var(--color-primary);
`;

export const NewPersonCardInformationButtonLabel = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);
`;

export const NewPersonCardQuickViewButton = styled.button`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: rgba(23, 28, 51, 0.5);
`;

interface NewPersonCardAvailabilityContainerProps {
  available: boolean;
}

export const NewPersonCardAvailabilityContainer = styled.div<NewPersonCardAvailabilityContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  padding: 2px 5px;

  border-radius: 4px;
  background: ${({ available }) =>
    available ? 'rgba(177, 211, 132, 0.7)' : 'rgba(212, 117, 99, 0.7)'};
`;

export const NewPersonCardAvailabilityText = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: var(--color-text);
`;

export const NewPersonCardMatchesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const NewPersonCardMatchesContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-top: 1px solid rgba(23, 28, 51, 0.1);
  padding-top: 5px;
  flex-wrap: wrap;
`;

export const NewPersonCardMatchesItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-right: 10px;
  margin-top: 10px;
`;

export const NewPersonCardMatchesItemLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  text-align: center;

  & > svg {
    transform: translateY(3px);
    margin-right: 4px;
  }

  color: rgba(23, 28, 51, 0.5);
`;
